require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/colored-icons/IconPremiumColored.tsx
var IconPremiumColored_exports = {};
__export(IconPremiumColored_exports, {
  default: () => IconPremiumColored_default
});
module.exports = __toCommonJS(IconPremiumColored_exports);

// src/assets/colored-icons/premium.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPremium = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M10.0056 1C14.9662 1 19.0056 5.04508 19 10.0056C18.9944 14.9662 14.9528 19.0056 9.99368 19C5.03455 18.9944 0.990174 14.9458 1.00002 9.97609C1.00986 5.02609 5.05212 0.996487 10.0056 1Z", fill: "url(#paint0_linear_18957_15266)" }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { filter: "url(#filter0_d_18957_15266)", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M14.5184 7.2977C14.7891 7.15511 15.0375 7.1855 15.2236 7.37563C15.393 7.55017 15.4241 7.76757 15.3843 8.00757C15.2157 9.0595 15.0417 10.2695 14.9384 10.988C14.8904 11.3217 14.8577 11.5494 14.8478 11.606C14.7891 11.9473 14.5871 12.139 14.2642 12.16H5.96424C5.4654 12.1593 5.28729 12.0073 5.20258 11.4837C5.07152 10.6701 4.99219 10.2217 4.91492 9.78492C4.83256 9.31934 4.75254 8.867 4.61469 7.99978C4.5727 7.73952 4.61252 7.50809 4.82393 7.33744C5.03534 7.16679 5.25761 7.1777 5.48784 7.29848C6.09489 7.61986 6.70559 7.93899 7.32657 8.26351C7.43733 8.32138 7.54841 8.37944 7.65986 8.4377C7.67522 8.40843 7.69016 8.38037 7.70473 8.353C7.72313 8.31843 7.74095 8.28495 7.75833 8.25147C7.91761 7.94303 8.07718 7.63473 8.23676 7.3264C8.63718 6.55277 9.03765 5.77903 9.43368 5.0029C9.5611 4.75589 9.72473 4.59926 10.0013 4.60004C10.2779 4.60082 10.4408 4.75822 10.5675 5.0068C10.9853 5.82557 11.4076 6.64169 11.8301 7.45815C11.9677 7.72408 12.1053 7.99004 12.2428 8.25615C12.2591 8.2912 12.2785 8.32565 12.3001 8.36405C12.3131 8.3871 12.3269 8.41159 12.3413 8.43848C12.5941 8.30605 12.8442 8.17453 13.093 8.04374C13.5703 7.79283 14.0424 7.54459 14.5184 7.2977Z", fill: "url(#paint1_linear_18957_15266)" }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M13.7804 13.2414H6.22038C5.92215 13.2414 5.68038 13.4832 5.68038 13.7814C5.68038 14.0797 5.92215 14.3214 6.22038 14.3214H13.7804C14.0786 14.3214 14.3204 14.0797 14.3204 13.7814C14.3204 13.4832 14.0786 13.2414 13.7804 13.2414Z", fill: "url(#paint2_linear_18957_15266)" })
  ] }),
  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("defs", { children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("filter", { id: "filter0_d_18957_15266", x: 4.09979, y: 4.40004, width: 11.8, height: 10.7214, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feOffset", { dy: 0.3 }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feGaussianBlur", { stdDeviation: 0.25 }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feComposite", { in2: "hardAlpha", operator: "out" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.729167 0 0 0 0 0.465451 0 0 0 0 0.0698785 0 0 0 1 0" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_18957_15266" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_18957_15266", result: "shape" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("linearGradient", { id: "paint0_linear_18957_15266", x1: 10, y1: 1, x2: 10, y2: 19, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { offset: 0.401042, stopColor: "#F9C642" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { offset: 1, stopColor: "#EBA429" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("linearGradient", { id: "paint1_linear_18957_15266", x1: 9.99979, y1: 4.60004, x2: 9.99979, y2: 14.3214, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { stopColor: "#FFFFFD" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { offset: 1, stopColor: "#FFECBC" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("linearGradient", { id: "paint2_linear_18957_15266", x1: 9.99979, y1: 4.60004, x2: 9.99979, y2: 14.3214, gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { stopColor: "#FFFFFD" }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("stop", { offset: 1, stopColor: "#FFECBC" })
    ] })
  ] })
] });
var premium_default = SvgPremium;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};

// src/Wrappers/IconColoredWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var IconColoredWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper",
      style: getIconBaseCssVariables(props),
      children: props.children
    }
  );
};

// src/icons/colored-icons/IconPremiumColored.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPremiumColored = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconColoredWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(premium_default, {}) });
};
IconPremiumColored.displayName = "IconPremiumColored";
var IconPremiumColored_default = IconPremiumColored;
